import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '影视分类',
      links: [
        { to: '/category/action', label: '动作片' },
        { to: '/category/comedy', label: '喜剧片' },
        { to: '/category/romance', label: '爱情片' },
        { to: '/category/scifi', label: '科幻片' },
        { to: '/category/horror', label: '恐怖片' },
      ],
    },
    {
      title: '更多内容',
      links: [
        { to: '/category/drama', label: '剧情片' },
        { to: '/category/animation', label: '动画片' },
        { to: '/category/documentary', label: '纪录片' },
        { to: '/category/tv-series', label: '电视剧' },
        { to: '/category/variety', label: '综艺节目' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { to: '/about', label: '品牌介绍' },
        { to: '/about', label: '信誉保障' },
        { to: '/about', label: '联系我们' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="col-span-2 md:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-500"></i>
                </div>
                <span className="font-heading text-xl font-bold text-foreground-900">
                  桃花影院
                </span>
              </Link>
              <p className="text-sm text-foreground-500 leading-relaxed">
                桃花影院 - 免费在线电影院，高清不缓冲，永久免费无需会员。最新电影、热播电视剧、热门综艺，尽在桃花影院。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-900 mb-3">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.to}
                        className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 桃花影院 taohua-cinema.com - 永久免费在线观影平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}